import React, { useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

import Modal from 'react-bootstrap/Modal';
import { Button } from 'react-bootstrap';
import ProgressSpinner
  from '@avtechsoftware/react-component-library/src/components/common/ProgressSpinner';
import envConfig from '../../../../envConfig';
import ShipmentTrackingTable from './ShipmentTrackingTable';

function ShipmentTrackingModal({
  trackingNumber, onClose, shipTo, shipFrom,
}) {
  const [shipMethod, setShipMethod] = useState('');
  const [signedForBy, setSignedForBy] = useState('');
  const [dataLoading, setDataLoading] = useState(true);
  const [activityList, setActivityList] = useState([]);
  const [dataAvailable, setDataAvailable] = useState(false);

  const getTrackingDetails = () => {
    axios.get(`${envConfig.raaUrl}/shipments/tracking-details/${trackingNumber}`)
      .then((response) => {
        const responseData = response.data.data.trackingDetails;
        setShipMethod(responseData.method);
        setSignedForBy(responseData.activity[0] ? responseData.activity[0].signedForByName : '');
        setShipMethod(typeof responseData.method === 'object' ? responseData.method['0'] : responseData.method);
        setActivityList(responseData.activity);
        setDataAvailable(true);
      })
      .catch(() => setDataAvailable(false))
      .finally(() => setDataLoading(false));
  };

  React.useEffect(getTrackingDetails, []);

  return (
    <>
      {' '}
      <Modal
        show
        onHide={onClose}
        size="xl"
      >
        <Modal.Header>
          <h3>Shipment Details</h3>
        </Modal.Header>
        <Modal.Body>
          <div className="col px-4">
            {!dataLoading ? (
              <>
                {dataAvailable ? (
                  <>
                    <div>
                      <b>Shipping Method:</b>
                      {' '}
                      {shipMethod}
                    </div>
                    <div>
                      <b>Tracking Number:</b>
                      {' '}
                      {trackingNumber}
                    </div>
                    <div>
                      <b>Ship From:</b>
                      {' '}
                      {shipFrom}
                    </div>
                    <div>
                      <b>Ship To:</b>
                      {' '}
                      {shipTo}
                    </div>
                    <div>
                      <b>Signed For By:</b>
                      {' '}
                      {signedForBy}
                    </div>
                    <div className="mt-5">
                      <ShipmentTrackingTable activityList={activityList} />
                    </div>
                  </>
                ) : (<div>Shipment info currently unavailable.</div>)}
              </>
            ) : (
              <div className="row d-flex justify-content-center">
                <div>
                  <ProgressSpinner progressText="Loading..." />
                </div>
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="text-right">
            <Button
              variant="secondary"
              onClick={onClose}
            >
              Close
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

ShipmentTrackingModal.propTypes = {
  shipTo: PropTypes.string.isRequired,
  shipFrom: PropTypes.string.isRequired,
  trackingNumber: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

ShipmentTrackingModal.defaultProps = {
  trackingNumber: '',
};

export default ShipmentTrackingModal;
